// ----------------------------------------------------------------------

export function path(root, sublink) {
  return `${root}${sublink}`;
}

export const ROOTS_DASHBOARD = '/dashboard';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  login: '/login',
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  one: path(ROOTS_DASHBOARD, '/one'),
  two: path(ROOTS_DASHBOARD, '/two'),
  three: path(ROOTS_DASHBOARD, '/three'),
  user: {
    root: path(ROOTS_DASHBOARD, '/user'),
    four: path(ROOTS_DASHBOARD, '/user/four'),
    five: path(ROOTS_DASHBOARD, '/user/five'),
    six: path(ROOTS_DASHBOARD, '/user/six'),
  },
  dashboard: {
    root: path(ROOTS_DASHBOARD, '/dashboard'),
  },
  vendors: {
    root: path(ROOTS_DASHBOARD, '/vendors'),
    create: path(ROOTS_DASHBOARD, '/vendors/create'),
    update: (id) => path(ROOTS_DASHBOARD, `/vendors/update/${id}`),
    histroy: path(ROOTS_DASHBOARD, '/vendors/histroy'),
  },
  ticket_orders: {
    root: path(ROOTS_DASHBOARD, '/ticket-orders'),
  },

  platformfee: {
    root: path(ROOTS_DASHBOARD, '/platformfee'),
    create: path(ROOTS_DASHBOARD, '/platformfee/create'),
    update: path(ROOTS_DASHBOARD, '/platformfee/update'),
  },
  invoices: {
    root: path(ROOTS_DASHBOARD, '/invoices'),
    create: path(ROOTS_DASHBOARD, '/invoices/create'),
    customer: path(ROOTS_DASHBOARD, '/invoices/customerinvoice'),
  },
  businessTags: {
    root: path(ROOTS_DASHBOARD, '/business-tags'),
    create: path(ROOTS_DASHBOARD, '/business-tags/create'),
    edit: (name) => path(ROOTS_DASHBOARD, `/business-tags/edit/${name}`),
  },

  packages: {
    root: path(ROOTS_DASHBOARD, '/packages'),
  },
  eventTags: {
    root: path(ROOTS_DASHBOARD, '/event-tags'),
    create: path(ROOTS_DASHBOARD, '/event-tags/create'),
    edit: (name) => path(ROOTS_DASHBOARD, `/event-tags/edit/${name}`),
  },
  sponsoredEvents: {
    root: path(ROOTS_DASHBOARD, '/sponsored-events'),
    create: path(ROOTS_DASHBOARD, '/sponsored-events/create'),
  },
  groupEvents: {
    root: path(ROOTS_DASHBOARD, '/group-events'),
    create: path(ROOTS_DASHBOARD, '/group-events/create'),
    edit: (name) => path(ROOTS_DASHBOARD, `/group-events/edit/${name}`),
  },
  cancelTickets: {
    root: path(ROOTS_DASHBOARD, '/cancel-tickets'),
    create: path(ROOTS_DASHBOARD, '/cancel-tickets/create'),
  },
  customer: {
    root: path(ROOTS_DASHBOARD, '/customer'),
  },
  pos: {
    root: path(ROOTS_DASHBOARD, '/pos'),
  },
  campaignPackage: {
    root: path(ROOTS_DASHBOARD, '/campaign/package'),
    create: path(ROOTS_DASHBOARD, '/campaign/package/create'),
    edit: (name) => path(ROOTS_DASHBOARD, `/campaign/package/edit/${name}`),
  },
  vendorCampaign: {
    root: path(ROOTS_DASHBOARD, '/campaign/all'),
    view: path(ROOTS_DASHBOARD, '/campaign/view'),
  },
  campaignCredits: {
    root: path(ROOTS_DASHBOARD, '/campaign/credits'),
    add: path(ROOTS_DASHBOARD, '/campaign/credits/add'),
    edit: (name) => path(ROOTS_DASHBOARD, `/campaign/credits/edit/${name}`),
  },
  campaignTemplate: {
    root: path(ROOTS_DASHBOARD, '/campaign/template'),
    add: path(ROOTS_DASHBOARD, '/campaign/template/add'),
    create: path(ROOTS_DASHBOARD, '/campaign/template/create'),
    default: path(ROOTS_DASHBOARD, '/campaign/template/create-default'),
  },
  campaignGroup: {
    root: path(ROOTS_DASHBOARD, '/campaign/group'),
  },
  maintenance: {
    root: path(ROOTS_DASHBOARD, '/maintenance'),
  },

  events: {
    root: path(ROOTS_DASHBOARD, '/events'),
    add: path(ROOTS_DASHBOARD, '/event-record/:id'),
  },

  discount: {
    root: path(ROOTS_DASHBOARD, '/discount'),
    add: path(ROOTS_DASHBOARD, '/discount/:id'),
  },

  Venues: {
    root: path(ROOTS_DASHBOARD, '/venues'),
    add: path(ROOTS_DASHBOARD, '/venues/type/:type'),
  },
  event_slot: {
    root: path(ROOTS_DASHBOARD, '/event-slot'),
    create: path(ROOTS_DASHBOARD, '/event-slot-create'),
    // add: path(ROOTS_DASHBOARD, '/venues/:id'),
  },
  staff: {
    root: path(ROOTS_DASHBOARD, '/staff'),

    // add: path(ROOTS_DASHBOARD, '/venues/:id'),
  },

  artist: {
    root: path(ROOTS_DASHBOARD, '/artist'),
    add: path(ROOTS_DASHBOARD, '/artist/details/:artistId/:mobile'),
  },

  EventLabels: {
    root: path(ROOTS_DASHBOARD, '/EventLabels'),
  },

  EventStrikes: {
    root: path(ROOTS_DASHBOARD, '/EventStrikes'),
    // add: path(ROOTS_DASHBOARD, '/venues/:id'),
  },
  Users: {
    root: path(ROOTS_DASHBOARD, '/users'),
    // add: path(ROOTS_DASHBOARD, '/venues/:id'),
  },
  Blogs: {
    root: path(ROOTS_DASHBOARD, '/Blogs'),
    create: path(ROOTS_DASHBOARD, '/Blogs/create'),
    edit: (id) => path(ROOTS_DASHBOARD, `/Blogs/edit/${id}`),
  },
  TableManagement: {
    root: path(ROOTS_DASHBOARD, '/TableManagement')
  },
  ClearEntryPage: {
    root: path(ROOTS_DASHBOARD, '/clear-entry')
  }
};
